import { useState } from "react";

export default function Section9() {
  const faqs = [
    {
      question: "How much do SEO services cost in New York?",
      answer:
        "SEO services in New York typically range from $1,000 to $10,000+ per month, depending on your industry, competition level, and campaign scope. Local SEO projects cost less, while competitive industries like finance, SaaS, or ecommerce require larger ongoing investments."
    },
    {
      question: "How long does SEO take to show results?",
      answer:
        "SEO usually takes 3 to 6 months to start showing noticeable improvements, with significant growth seen over 6–12 months. The timeline depends on your website’s current condition, competition, and the strength of your SEO strategy."
    },
    {
      question: " Is SEO worth it for my business in New York?",
      answer:
        "Yes, SEO is one of the most effective long-term marketing strategies. In a competitive market like New York, it helps your business gain consistent organic traffic, build credibility, and generate qualified leads without relying solely on paid ads."
    },
    {
      question: "What is included in your SEO services?",
      answer:
        "SEO services typically include technical SEO, on-page optimization, content strategy, keyword research, link building, and performance tracking. A complete strategy ensures your website ranks higher and converts traffic into customers."
    },
    {
      question: " Can you guarantee #1 rankings on Google?",
      answer:
        "No reputable SEO agency can guarantee #1 rankings because search engines constantly update their algorithms. However, a professional SEO company focuses on sustainable growth, improved rankings, and measurable traffic increases over time."
    },
    {
      question: "Do you provide local SEO for New York businesses?",
      answer:
        "Yes, local SEO focuses on improving visibility in location-based searches. This includes Google Business Profile optimization, local citations, map rankings, and geo-targeted keywords to attract customers in New York."
    },
    
  ];

  const [isOpen, setIsOpen] = useState(new Array(faqs.length).fill(false));

  const handleFaq = (index) => {
    setIsOpen((prevState) =>
      prevState.map((item, idx) => (idx === index ? !item : false))
    );
  };

  return (
    <div className="w-full Section9 mt-[8%] md:mt-[4%]">
      <div className="w-full section9-container">
        <div className="w-[90%] md:w-[61%] pb-[1%] mx-auto text-center">
          <h2 className="leading-[29px] md:leading-[41px] text-[24px] md:text-[34px] text-[#151515] font-bold my-[0.67em]">
            FAQs about SEO Services
          </h2>
        </div>

        <div className="w-full md:w-[784px] p-5 md:p-[2%] mx-auto faq-container font-open leading-[21px]">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="faq-item text-[11px] md:text-sm rounded-[8px] p-[2%] border border-solid border-[#DEDEDE] mb-[4%]"
              style={{
                background:
                  "linear-gradient(0deg, #FEFFFF, #FEFFFF), linear-gradient(0deg, #DEDEDE, #DEDEDE)",
              }}
            >
              <div
                onClick={() => handleFaq(index)}
                className="question text-[#444444] cursor-pointer flex justify-between items-center"
              >
                {faq.question}
                <b className="text-[40px] text-[#DA2128] font-[300]">
                  {isOpen[index] ? "-" : "+"}
                </b>
              </div>
              <div className={`${isOpen[index] ? "block" : "hidden"} answer text-[#444444]`}>
                <br />
                <p className="mb-5">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="line mb-[55px] md:mb-[4%] mt-[1%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
    </div>
  );
}
